// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
th,td{
  padding:6px;
}

.summary {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.summary-container {
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.reload-btn {
  display: flex;
  flex-direction: row;
}

.header {
  background-color: #f5f5f5;
  padding: 12px 16px;
  font-weight: bold;
  width: 100%;
  border-bottom: 1px solid #ddd;
}

.content {
  padding: 16px;
}

.info-section {
  margin-bottom: 20px;
}

.info-section:last-child {
  margin-bottom: 0;
}

.info-header {
  font-weight: bold;
  color: #666;
  margin-bottom: 8px;
}

.info-content {
  padding: 8px;
  background-color: #f9f9f9;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/app/workflow-ai-summary/workflow-ai-summary.component.css"],"names":[],"mappings":";AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":["\nth,td{\n  padding:6px;\n}\n\n.summary {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.summary-container {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.reload-btn {\n  display: flex;\n  flex-direction: row;\n}\n\n.header {\n  background-color: #f5f5f5;\n  padding: 12px 16px;\n  font-weight: bold;\n  width: 100%;\n  border-bottom: 1px solid #ddd;\n}\n\n.content {\n  padding: 16px;\n}\n\n.info-section {\n  margin-bottom: 20px;\n}\n\n.info-section:last-child {\n  margin-bottom: 0;\n}\n\n.info-header {\n  font-weight: bold;\n  color: #666;\n  margin-bottom: 8px;\n}\n\n.info-content {\n  padding: 8px;\n  background-color: #f9f9f9;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
